<header
  class="gc-chat-widget-header header bc-panel row-flex-container column-flex-fix"
  [ngClass]="{ expanded: isExpandedMode }"
>
  <div class="visitor-avatar">
    <svg-avatar [id]="avatarThemeId"></svg-avatar>
  </div>

  <div class="visitor-name row-flex-grow">
    <app-genesys-contact-display-name [contact]="contact"></app-genesys-contact-display-name>
  </div>

  <app-genesys-widget-header-tools
    [isExpandedMode]="isExpandedMode"
    [integrations]="integrations"
    [openIntegrationPanels]="openIntegrationPanels"
    [isCobrowseAllowed]="isCobrowseAllowed"
    [isCobrowseActive]="isCobrowseActive"
    (minimize)="minimize.emit()"
    (toggleExpanded)="toggleExpanded.emit()"
    (toggleCobrowse)="toggleCobrowse.emit($event)"
    (toggleIntegration)="toggleIntegration.emit($event)"
  >
  </app-genesys-widget-header-tools>
</header>
